export default {
    language: 'Language',
    organisation: 'Organisation',
    roles: 'Roles'
}
